module.exports = __webpack_public_path__ + "static/mieszkania-puck-rynek-pierwotny-7dc9b570297852f3387d72511720001b.jpg";